import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '@src/service/axios';
import { toast } from 'react-toastify';

// Loader Components
import showLoader from '@components/loader';
// import themeConfig from '../../../../configs/themeConfig';
import themeConfig from '../../../configs/themeConfig';
import queryString from 'query-string';
const initialTakeOwnerShipfun = () => {
    const item = window.localStorage.getItem('takeOwnerShip');

    return item ? JSON.parse(item) : themeConfig.layout.takeOwnerShip;
};

export const getVehicleOptionWithFilter = createAsyncThunk('vehicleSlice/getVehicleOptionWithFilter', async (data) => {
    try {
        // showLoader(true);
        const query = queryString.stringify(data);

        let response = await axios.get('/vehicle/with-filters?option=true&skip=0&take=5' + `&${query}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        // showLoader(false);
        return Promise.resolve(response.data.data.rows);
    } catch (err) {
        // showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getVehicleStatistics = createAsyncThunk('vehicleSlice/getVehicleStatistics', async (data) => {
    try {
        // showLoader(true);
        const query = queryString.stringify(data);

        let response = await axios.get('/dashboard-statistics' + `?${query}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        // showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        // showLoader(false);
        // toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getOBDdeviceStatistics = createAsyncThunk('vehicleSlice/getVehicleStatistics', async (data) => {
    try {
        // showLoader(true);

        let response = await axios.post('/obd-device/statistics/' + `${data.vehicleId}`, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        // showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        // showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getLiveTracking = createAsyncThunk('vehicleSlice/getLiveTracking', async (data) => {
    try {
        const query = queryString.stringify(data);

        let response = await axios.get('/live-tracking-data' + `?${query}`, {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: true
        });

        return Promise.resolve(response?.data?.data);
    } catch (err) {
        // showLoader(false);
        // toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getVehicleSpecification = createAsyncThunk('vehicleSlice/getVehicleSpecification', async (data) => {
    try {
        // showLoader(true);
        const query = queryString.stringify(data);

        let response = await axios.get('/dashboard/vehicle-specification' + `?${query}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        // showLoader(false);
        return Promise.resolve(response.data.data);
    } catch (err) {
        // showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getVehicleViolation = createAsyncThunk('vehicleSlice/getVehicleViolation', async (data) => {
    try {
        // showLoader(true);
        const query = queryString.stringify(data);

        let response = await axios.get('/dashboard/vehicle-violations' + `?${query}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        // showLoader(false);
        return Promise.resolve(response.data.data);
    } catch (err) {
        // showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getChallanDetails = createAsyncThunk('vehicleSlice/getChallanDetails', async (data) => {
    try {
        // showLoader(true);
        const { vehicleId, startDate, endDate } = data;
        const query = `startDate=${startDate}&endDate=${endDate}`;
        let response = await axios.get('/challan-details/' + vehicleId + `?${query}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        // showLoader(false);
        return Promise.resolve(response.data.data);
    } catch (err) {
        // showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getStatisticsOfVehicle = createAsyncThunk('vehicleSlice/getStatisticsOfVehicle', async (data) => {
    try {
        // showLoader(true);
        const query = queryString.stringify(data);
        let response = await axios.get(`/dashboard/statistics-counts?${query}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        // showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        // showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getStatisticsList = createAsyncThunk('vehicleSlice/getStatisticsList', async (data) => {
    try {
        const query = queryString.stringify(data);
        let response = await axios.get(`/statistics-list` + `?${query}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response.data.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getSatelliteStatisticsCount = createAsyncThunk('vehicleSlice/getSatelliteStatisticsCount', async (data) => {
    try {
        const query = queryString.stringify(data);
        let response = await axios.get(`/dashboard/satellite-statistics-counts` + `?${query}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        return Promise.resolve(response.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getVehicleCategoryCounts = createAsyncThunk('vehicleSlice/getVehicleCategoryCounts', async (index) => {
    try {
        // showLoader(true);

        let response = await axios.get(`/dashboard/vehicle-category-counts-v2`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        // showLoader(false);
        return Promise.resolve(response.data.data);
    } catch (err) {
        // showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getDashboardCountLists = createAsyncThunk('vehicleSlice/getDashboardCountLists', async (data) => {
    try {
        // showLoader(true);
        const query = queryString.stringify(data);

        let response = await axios.get(`/dashboard-count-list` + `?${query}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        // showLoader(false);
        return Promise.resolve(response.data.data);
    } catch (err) {
        // showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getEventsDataList = createAsyncThunk('vehicleSlice/getEventsDataList', async (data) => {
    try {
        const query = `type=${data.index}&vehicleId=${data.vehicleId}`;
        let response = await axios.get(`/events-data?${query}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        return Promise.resolve(response.data.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getVehicleInfo = createAsyncThunk('vehicleSlice/getVehicleInfo', async (id) => {
    try {
        showLoader(true);
        let response = await axios.get(`/vehicle-data/${id}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        showLoader(false);
        return Promise.resolve(response.data.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});
export const getMongoTrips = createAsyncThunk('fleetsSlice/getMongoTrips', async (data) => {
    try {
        const query = queryString.stringify(data);
        showLoader(true);
        let response = await axios.get('/mongo-vehicle-trip?' + `${query}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        showLoader(false);
        return Promise.resolve(response.data.data.rows);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const dashboardSlice = createSlice({
    name: 'dashboardSlice',
    initialState: {
        data: [],
        options: [],
        selectedRole: {},
        module: [],
        initialTakeOwnerShip: initialTakeOwnerShipfun(),
        optionWithFilter: [],
        statisticsOfVehicle: {},
        satelliteStatistics: {},
        statisticsList: [],
        eventsDataList: [],
        vehicleInfo: {},
        mongoTrips: [],
        vehicleCategoryCounts: []
    },
    reducers: {
        handleTackOwherShip: (state, action) => {
            state.initialTakeOwnerShip = action.payload;
            localStorage.setItem('takeOwnerShip', JSON.stringify(action.payload));
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getVehicleOptionWithFilter.fulfilled, (state, action) => {
            state.optionWithFilter = action.payload;
            return;
        });
        builder.addCase(getStatisticsOfVehicle.fulfilled, (state, action) => {
            state.statisticsOfVehicle = action.payload;
            return;
        });
        builder.addCase(getSatelliteStatisticsCount.fulfilled, (state, action) => {
            state.satelliteStatistics = action.payload;
            return;
        });
        builder.addCase(getStatisticsList.fulfilled, (state, action) => {
            state.statisticsList = action.payload;
            return;
        });
        builder.addCase(getEventsDataList.fulfilled, (state, action) => {
            state.eventsDataList = action.payload;
            return;
        });
        builder.addCase(getVehicleInfo.fulfilled, (state, action) => {
            state.vehicleInfo = action.payload;
            return;
        });
        builder.addCase(getMongoTrips.fulfilled, (state, action) => {
            state.mongoTrips = action.payload;
            return;
        });
        builder.addCase(getVehicleCategoryCounts.fulfilled, (state, action) => {
            state.vehicleCategoryCounts = action.payload;
            return;
        });
    }
});

export const { handleTackOwherShip } = dashboardSlice.actions;

export default dashboardSlice.reducer;
